export default __webpack_public_path__ + "static/media/4f5d83ed32fb73f19eae7a2dd5674a75.png";